module.exports = require('./helpers/bundle-url').getBundleURL('7cmdB') + "logo.c51670a8.svg";